import * as type from "../types/single-campaign";

const initialState = {
  details: {
    name: null,
    description: null,
  },
  records: [],
  deletionArray: [],
  fetchDetails: {
    status: null,
    loading: true,
    error: null,
  },
  fetchRecords: {
    status: null,
    loading: true,
    error: null,
  },
  activeDisplay: {},
  activeEdit: {},
  activeDeletion: {
    id: null,
  },
  showModals: {
    newModal: false,
  },
};

export const singleCampaign = (state = initialState, payload) => {
  switch (payload.type) {
    case type.CHANGE_SINGLE_CAMPAIGN_MODAL:
      if (payload.modal.newModal === true || payload.modal.newModal === false) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            newModal: payload.modal.newModal,
          },
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};
